import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import InvoicePrint from "@/components/InvoicePrint";
import { Button } from "@/components/ui/button";
import { Printer } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

export default function PublicInvoice() {
  const { token } = useParams();
  const [inv, setInv] = useState(null);
  const [err, setErr] = useState("");
  const [format, setFormat] = useState("a4");

  useEffect(() => {
    axios.get(`${API}/public/invoice/${token}`)
      .then((r) => { setInv(r.data); setFormat(r.data.company?.print_default_format || "a4"); })
      .catch(() => setErr("This invoice link is invalid or has expired."));
  }, [token]);

  if (err) return <div className="min-h-screen grid place-items-center text-slate-500 p-6 text-center" data-testid="public-invoice-error">{err}</div>;
  if (!inv) return <div className="min-h-screen grid place-items-center text-slate-400">Loading…</div>;

  return (
    <div className="min-h-screen bg-slate-100 py-8" data-testid="public-invoice-page">
      <div className="max-w-4xl mx-auto px-4">
        <div className="no-print flex items-center justify-between mb-4 flex-wrap gap-3">
          <div className="font-heading font-bold text-lg">{inv.company?.name}</div>
          <div className="flex items-center gap-2">
            <div className="flex rounded-md border border-slate-200 overflow-hidden">
              {["a4", "a5", "thermal"].map((f) => (
                <button key={f} onClick={() => setFormat(f)}
                  className={`px-3 py-1.5 text-xs font-medium uppercase ${format === f ? "bg-slate-900 text-white" : "bg-white text-slate-600 hover:bg-slate-50"}`}>{f}</button>
              ))}
            </div>
            <Button size="sm" variant="print" onClick={() => window.print()} data-testid="public-print-button"><Printer className="h-4 w-4 mr-1" /> Print / Download</Button>
          </div>
        </div>
        <div className="bg-white shadow-lg mx-auto" style={{ width: "fit-content" }}>
          <InvoicePrint invoice={inv} format={format} printArea={false} />
        </div>
        <div className="hidden print:block"><InvoicePrint invoice={inv} format={format} printArea /></div>
      </div>
    </div>
  );
}
